<template>
  <app-view :title="info.docs?.procedure?.title || '購買流程'" :backable="true">
    <div class="p-5">
      <div v-if="info.docs?.procedure?.content" class="prose max-w-none text-sm text-chicago break-words" v-html="info.docs.procedure.content"></div>
      <img v-else-if="imgs.procedure" :src="imgs.procedure" alt="" />
    </div>
  </app-view>
</template>

<script>
import {mapGetters} from "vuex";
export default {
  auth: false,
  head() {
    const appName = this.$store.getters['app/info']?.name || process.env.APP_NAME;
    const title = this.info?.docs?.procedure?.title || '購買流程';
    return {
      title: `${appName}-${title}`,
      meta: [
        {
          hid: "keywords",
          name: "keywords",
          content: `${appName},${appName}-${title}`,
        },
        {
          hid: "description",
          name: "description",
          content: `${appName}${title}幫助您在本平台進行愉快的購物。`,
        },
        {
          hid: "og:title",
          name: "og:title",
          property: "og:title",
          content: `${appName}-${title}`,
        },
        {
          hid: "og:site_name",
          name: "og:site_name",
          property: "og:site_name",
          content: appName,
        },
        {
          hid: "og:url",
          name: "og:url",
          property: "og:url",
          content: `${process.env.APP_URL}/procedure`,
        },
        {
          hid: "og:description",
          name: "og:description",
          property: "og:description",
          content: `${process.env.APP_NAME}${title}幫助您在本平台進行愉快的購物。`,
        },
        {
          hid: "og:image",
          name: "og:image",
          property: "og:image",
          content: `${process.env.APP_URL}/static/icon.png`,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      imgs: "app/imgs",
      info: "app/info",
    }),
  },
};
</script>

<style scoped>
.prose >>> img {
  width: 100%;
  height: auto;
}
</style>
